/**
 * Shared suggestion/postback action type labels and configurations.
 * Used by analytics pages and bot builder components (e.g. popper).
 *
 * Single source of truth for action type display labels.
 */

/**
 * Canonical mapping of postback_action_type values to display labels.
 */
export const SUGGESTION_ACTION_LABELS = {
  bot_flow: "Start a bot flow",
  livechat: "Ping live chat",
  agent_or_group: "Ping live chat (assign to agent)",
  website: "Open a URL",
  custom: "Custom payload",
  phone_number: "Dial a number",
  location: "Share a location",
  share: "Request a location",
  calendar: "Create a calendar event",
  opt_in: "Marketing Opt-in",
  opt_out: "Marketing Opt-out",
  app_webview: "Open a URL (webview)",
  suggested_reply: "Suggested Reply",
  continue: "Continue from previous step"
};

/**
 * Returns the display label for a suggestion's postback action type.
 * @param {Object} item - Object with `postback_action_type` property
 * @returns {string} Human-readable label or 'N/A' if missing
 */
export function getSuggestionTypeLabel(item) {
  if (!item.postback_action_type) return 'N/A';
  return SUGGESTION_ACTION_LABELS[item.postback_action_type] || item.postback_action_type;
}

/**
 * Returns a fresh copy of the default popper action options.
 * Each call returns a new object to avoid shared mutation across component instances.
 *
 * Keys are internal option identifiers used by the popper component.
 * Labels are derived from the canonical SUGGESTION_ACTION_LABELS map.
 */
export function getPopperActionOptions() {
  return {
    botFlow: {
      text: SUGGESTION_ACTION_LABELS.bot_flow,
      enable: true
    },
    pingLiveChat: {
      text: SUGGESTION_ACTION_LABELS.livechat,
      enable: true
    },
    liveChat: {
      text: SUGGESTION_ACTION_LABELS.agent_or_group,
      enable: true
    },
    openWebSite: {
      text: SUGGESTION_ACTION_LABELS.website,
      enable: true
    },
    whatsappCarouselUrl: {
      text: SUGGESTION_ACTION_LABELS.website,
      enable: false
    },
    customPayload: {
      text: SUGGESTION_ACTION_LABELS.custom,
      enable: true
    },
    continue: {
      text: SUGGESTION_ACTION_LABELS.continue,
      enable: true
    },
    phone_number: {
      text: SUGGESTION_ACTION_LABELS.phone_number,
      enable: true
    },
    location: {
      text: SUGGESTION_ACTION_LABELS.location,
      enable: false
    },
    share: {
      text: SUGGESTION_ACTION_LABELS.share,
      enable: false
    },
    calendar: {
      text: SUGGESTION_ACTION_LABELS.calendar,
      enable: false
    },
    optIn: {
      text: SUGGESTION_ACTION_LABELS.opt_in,
      enable: true
    },
    optOut: {
      text: SUGGESTION_ACTION_LABELS.opt_out,
      enable: true
    }
  };
}
